import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
interface DropdownItem {
  id: string;
  name: string;
}
@Component({
  selector: 'app-auto-complete',
  imports: [CommonModule,FormsModule,ReactiveFormsModule,NgbModule],
  templateUrl: './auto-complete.component.html',
  styleUrl: './auto-complete.component.scss'
})
export class AutoCompleteComponent implements OnInit , OnChanges{

  @Input() placeholder : string =''
  @Input() readonly : boolean = false

  @Input() header : string =''
  @Input() options: { list: { id: string; name: string }[] } = { list: [] };
  @Input() keyRequired = false;
  @Input() id :string = ""
  @Input() idSelect:boolean = false
  @Output() selecteditem = new EventEmitter<{id:string,value:string,name?: string;}>()
  @Input() checkValidation :boolean = false
  @Input() existingValue : string = ''
  @Input() icon: boolean | string = false;
  @Input() iconName: string = '';
  @Output() requiredKey = new EventEmitter<{id:string,required:boolean}>()

  get hasIcon(): boolean {
    return !!(this.icon === true ||
              (typeof this.icon === 'string' && this.icon.trim() !== '' && this.icon !== 'false') ||
              this.iconName);
  }

  get resolvedIconClass(): string {
    const ic = (typeof this.icon === 'string' && this.icon !== 'true' && this.icon !== 'false'
      ? this.icon
      : this.iconName || '').trim();
    if (!ic) return 'fa fa-list';
    if (ic.startsWith('fa-') && !ic.includes(' ')) return `fa ${ic}`;
    return ic;
  }

  searchTerm = '';
  selectedItems: Record<string, string> = {};
  showRequiredError = false;
  selectedValue: string = ''; // single selected value
  itemnotmatch:boolean = true
  internalOptions: DropdownItem[] = []; // converted array for filtering
  private lastEmitted: { id: string; value: string } | null = null;


  ngOnInit(): void {
    if (this.keyRequired === true) {
      setTimeout(() => {
        this.requiredKey.emit({ id: this.id, required: this.keyRequired });
      }, 300);
    }

    // ✅ Handle initial existingValue
    this.applyExistingValue();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['options']) {
      this.internalOptions = this.options?.list || [];
      this.applyExistingValue();

    }

    if (this.checkValidation === true && !this.selectedValue) {
      this.showRequiredError = true;
    }

    if (changes['existingValue'] && changes['existingValue'].currentValue) {
      // ✅ Handle updated existingValue
      this.applyExistingValue();
    }
  }

  /**
   * Handles all cases for existingValue:
   * 1. Y/N special mapping
   * 2. Country/State → match by id
   * 3. Normal → match by name
   */
private applyExistingValue(): void {
  if (!this.existingValue || !this.options?.list?.length) return;

  let emitPayload: { id: string; value: string; name: string } | null = null;

  // ✅ Case 1: Y/N
  if (
    (this.existingValue === 'Y' || this.existingValue === 'N') &&
    this.options.list.some(
      opt =>
        opt.name.toLowerCase() === 'yes' ||
        opt.name.toLowerCase() === 'no'
    )
  ) {
    this.searchTerm = this.existingValue === 'Y' ? 'Yes' : 'No';
    this.selectedValue = this.existingValue;
    emitPayload = {
      id: this.id,
      value: this.existingValue,
      name: this.searchTerm === 'Yes'?'Y':'N',
    };
  }

  // ✅ Case 2: idSelect true → match by id
  else if (this.idSelect === true) {
    const matchById = this.options.list.find(
      item => item.id === this.existingValue
    );
    if (matchById) {
      this.searchTerm = matchById.name;
      this.selectedValue = matchById.id;
      emitPayload = {
        id: this.id,
        value: matchById.id,
        name: matchById.id,
      };
    }
  }

  // ✅ Case 3: country/state
  else if (this.id === 'country' || this.id === 'state') {
    const matchByName = this.options.list.find(
      item => item.name.toLowerCase() === this.existingValue.toLowerCase()
    );
    if (matchByName) {
      this.searchTerm = matchByName.name;
      this.selectedValue = matchByName.name;
      emitPayload = {
        id: this.id,
        value: matchByName.id,
        name: matchByName.name,
      };
    }
  }

  // ✅ Case 4: normal
  else {
    const matchByName = this.options.list.find(
      item => item.name.toLowerCase() === this.existingValue.toLowerCase()
    );
    if (matchByName) {
      this.searchTerm = matchByName.name;
      this.selectedValue = matchByName.name;
      emitPayload = {
        id: this.id,
        value: matchByName.name,
        name: matchByName.name,
      };
    }
  }

  // ✅ Emit only if changed
  if (
    emitPayload &&
    (!this.lastEmitted ||
      this.lastEmitted.value !== emitPayload.value ||
      this.lastEmitted.id !== emitPayload.id)
  ) {
    this.selecteditem.emit(emitPayload);
    this.lastEmitted = { id: emitPayload.id, value: emitPayload.value };
  }
}


selectOption(item: DropdownItem) {
  if (item.id === 'none') return;

  this.searchTerm = item.name;
  this.selectedValue = this.idSelect ? item.id : item.name;
  this.showRequiredError = false;

  // ✅ special case for Yes/No → emit Y or N
  if (item.name.toLowerCase() === 'yes' || item.name.toLowerCase() === 'no') {
    const value = item.name.toLowerCase() === 'yes' ? 'Y' : 'N';
    this.selecteditem.emit({ id: this.id, value, name: item.name });
    return;
  }

  // ✅ If idSelect is true → emit id
  if (this.idSelect === true) {
    const payload = {
      id: this.id,
      value:item.id,
      name:item.id
    }
    console.log(payload);
    
    this.selecteditem.emit(payload)
    return;
  }

  // ✅ country/state → emit actual id + name
  if (this.id === 'country' || this.id === 'state') {
    this.selecteditem.emit({ id: this.id, value: item.id, name: item.name });
  } else {
    // ✅ normal → still include name for consistency
    this.selecteditem.emit({ id: this.id, value: item.name, name: item.name });
  }
}




  get filteredItems(): DropdownItem[] {
    if (!this.internalOptions.length) {
      // no data at all → handled in template with "No items"
      return [];
    }

    if (!this.searchTerm.trim()) {
      return this.internalOptions;
    }

    const lowerSearchTerm = this.searchTerm.toLowerCase();

    const sortedItems = [...this.internalOptions].sort((a, b) => {
      const aIncludes = a.name.toLowerCase().includes(lowerSearchTerm);
      const bIncludes = b.name.toLowerCase().includes(lowerSearchTerm);

      if (aIncludes && !bIncludes) return -1;
      if (!aIncludes && bIncludes) return 1;
      return a.name.localeCompare(b.name);
    });

    const hasMatch = sortedItems.some(opt =>
      opt.name.toLowerCase().includes(lowerSearchTerm)
    );

    if (!hasMatch) {
      return [{ id: 'none', name: 'Item does not exist' }];
    }

    return sortedItems;
  }


  onDropdownOpenChange(isOpen: boolean) {
    // When dropdown closes, check if required and no value
    if (!isOpen && this.keyRequired && !this.selectedValue.trim()) {
      this.showRequiredError = true;
    }
  }
  onInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.searchTerm = input.value;
    this.selectedValue = input.value.trim();

    if (this.keyRequired && !this.selectedValue) {
      this.showRequiredError = true;
    } else {
      this.showRequiredError = false;
    }
  }
}
